import { Inject } from "@angular/core";
import { Events } from "ionic-angular";
import { ConversationsSettingsEvent, EncryptStorage } from "../..";
import { StorageData } from "../../storage/storage-data";
import { StorageType } from "../../storage/storage-type";
var MessengerModel = /** @class */ (function () {
    function MessengerModel(storage, events) {
        this.storage = storage;
        this.events = events;
        this._keyItem = "messengers";
    }
    MessengerModel.prototype.save = function (storageData) {
        storageData.key = "welcome-visited";
        storageData.item = this._welcomeVisited;
        storageData.encrypt = false;
        return this.storage.saveAs(storageData);
    };
    MessengerModel.prototype.loadWelcomeVisited = function () {
        var _this = this;
        this.storage.load(this._keyItem + "welcome-visited", false, StorageType.SESSION).then(function (res) {
            if (res != null && typeof res != 'string') {
                _this._welcomeVisited = res;
                _this.events.publish(MessengerEvents.WELCOME_LOADED, _this._welcomeVisited);
            }
        });
    };
    Object.defineProperty(MessengerModel.prototype, "welcomeVisited", {
        get: function () {
            return this._welcomeVisited;
        },
        enumerable: true,
        configurable: true
    });
    MessengerModel.prototype.setWelcomeVisited = function (value, preventDefault) {
        this._welcomeVisited = value;
        var storageData = new StorageData(MessengerEvents.WELCOME_CHANGED, preventDefault, value, false, StorageType.SESSION);
        storageData.key = this._keyItem + "welcome-visited";
        storageData.item = value;
        return this.storage.saveAs(storageData);
    };
    MessengerModel.prototype.clear = function (preventDefault, preventSave) {
        this._welcomeVisited = false;
        var storageData = new StorageData(ConversationsSettingsEvent.CLEARED, preventDefault);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    /** @nocollapse */
    MessengerModel.ctorParameters = function () { return [
        { type: EncryptStorage, decorators: [{ type: Inject, args: [EncryptStorage,] },] },
        { type: Events, decorators: [{ type: Inject, args: [Events,] },] },
    ]; };
    return MessengerModel;
}());
export { MessengerModel };
export var MessengerEvents;
(function (MessengerEvents) {
    MessengerEvents["CLEARED"] = "messenger:cleared";
    MessengerEvents["WELCOME_LOADED"] = "messenger-welcome:loaded";
    MessengerEvents["WELCOME_CHANGED"] = "messenger-welcome:visited";
})(MessengerEvents || (MessengerEvents = {}));
//# sourceMappingURL=messenger-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/messenger/messenger-model.js
// module id = 384
// module chunks = 14